var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.16 3.29443H7.38701C7.22501 3.29443 7.06965 3.35879 6.9551 3.47334C6.84055 3.58789 6.7762 3.74325 6.7762 3.90524V6.9593H3.72214C3.56014 6.9593 3.40478 7.02365 3.29023 7.1382C3.17568 7.25275 3.11133 7.40811 3.11133 7.57011V17.3431C3.11133 17.5051 3.17568 17.6605 3.29023 17.775C3.40478 17.8896 3.56014 17.9539 3.72214 17.9539H13.4951C13.6571 17.9539 13.8125 17.8896 13.927 17.775C14.0416 17.6605 14.1059 17.5051 14.1059 17.3431V14.289H17.16C17.322 14.289 17.4773 14.2247 17.5919 14.1101C17.7064 13.9956 17.7708 13.8402 17.7708 13.6782V3.90524C17.7708 3.74325 17.7064 3.58789 17.5919 3.47334C17.4773 3.35879 17.322 3.29443 17.16 3.29443ZM12.8843 16.7323H4.33295V8.18092H12.8843V16.7323ZM16.5492 13.0674H14.1059V7.57011C14.1059 7.40811 14.0416 7.25275 13.927 7.1382C13.8125 7.02365 13.6571 6.9593 13.4951 6.9593H7.99782V4.51606H16.5492V13.0674Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610811
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.a7ec8c536082daa4b28e99844c8371af.svg";
export { ForwardRef as ReactComponent };